/**
 * These are format strings that can be used with Moment.
 *
 * The difference between the TIME and DATE formats is the times ones are used where the time is the most important
 * thing being shown and the date might be optional to differentiate from another time.
 * The date formats are where the date is the most important thing and the time might be optionally added.
 */
const DateFormat = {
    TIME: 'h:mm A', // 1:23 PM
    TIME_WITH_DATE: 'MMM Do h:mm A', // Jan 25th 1:23 PM
    TIME_WITH_DATE_WITH_SECS: 'MMM Do h:mm:ss A', // Jan 25th 1:23:45 PM
    DATE: 'ddd MMM Do YYYY', // Mon Jan 25th 2021
    DATE_ALTERNATE: 'ddd D MMM', // Mon 4 Jan
    DATE_SHORT: 'DD/MM/YYYY', // 05/01/2023
    DATE_WITH_TIME: 'ddd MMM Do YYYY h:mm A', // Mon Jan 25th 2021 1:23 PM
    DATE_WITH_TIME_WITH_SECS: 'ddd MMM Do YYYY h:mm:ss A', // Mon Jan 25th 2021 1:23:45 PM

    RECEIPT: 'D/M/YY H:mm', // 25/1/21 13:23
};

module.exports = DateFormat;
